import { Activity } from "../../../Types/DirectLine";

const tokenUrl = 'https://95a00d7b2c29e22d9e507fee77298e.14.environment.api.powerplatform.com/powervirtualagents/botsbyschema/cre02_askJiro/directline/token?api-version=2022-03-01-preview'
const directlineUrl = 'https://directline.botframework.com/v3/directline/conversations';
let convoId = '';
let stream = '';

const getToken = async () => {
    const response = await fetch(tokenUrl, { method: 'GET' });

    if (!response.ok) {
        throw new Error(`Token request failed: ${response.status}`);
    }

    const json = await response.json();
    console.log(json);
    return json.token;
};

const agentConnect = async (token: string) => {
    const response = await fetch(directlineUrl, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    if (!response.ok) {
        throw new Error(`Connection failed: ${response.status}`);
    }

    const json = await response.json();

    const { streamUrl, conversationId } = json;

    convoId = conversationId;
    stream = streamUrl;

};

const connectToStream = (
    streamUrl: string,
    onMessage: (activity: Activity) => void
) => {
    const socket = new WebSocket(streamUrl);

    socket.onopen = () => {
        console.log('Connected to Stream');
    };

    socket.onmessage = (event) => {
        if (!event.data) {
            console.log("Empty websocket message.");
            return;
        }
        try {
            const data = JSON.parse(event.data);
    
            if (data.activities) {
                data.activities.forEach((activity: Activity) => {
                    console.log(data.activities);
                    if (activity.from.role === "bot") {
                        onMessage(activity);
                    }
                });
            }
        } catch (err) {
            console.error(
                'Failed to parse websocket message:',
                event.data,
                err
            );
        }
    };

    socket.onerror = (error) => {
        console.error('Socket Error:', error);
    };

    socket.onclose = () => {
        console.log('Socket Closed');
    };

    return socket;
};

const startConvo = async (conversationId: string, token: string) => {
    const response = await fetch(
        `${directlineUrl}/${conversationId}/activities`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                type: "event",
                name: "startConversation",
                from: {
                    id: "user"
                },
                channelId: "webchat",
                entities: [
                    {
                        type: "ClientCapabilities",
                        requiresBotState: true,
                        supportsListening: true,
                        supportsTts: true
                    }
                ]
            })
        }
    );

    if (!response.ok) {
        throw new Error(`startConversation failed: ${response.status}`);
    }

    const json = await response.json();
    console.log("StartConvo Res:", json);
};

export const getJiro = async (
    onMessage: (activity: Activity) => void
) => {
    try {
        const token = await getToken();

        if (!token) {
            throw new Error('Token not returned from server');
        }

        await agentConnect(token);

        let socket: WebSocket | undefined;

        if (stream) {
            socket = connectToStream(stream, onMessage);
        }

        if (convoId) {
            await startConvo(convoId, token);
        }

        return {
            socket,
            conversationId: convoId,
            token
        };

    } catch (e) {
        console.error('CopilotTest Error:', e);
    }
};

export const sendMessage = async (
    conversationId: string,
    token: string,
    text: string
) => {
    const response = await fetch(`${directlineUrl}/${conversationId}/activities`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            type: "message",
            from: { id: "user" },
            text
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`DirectLine error: ${response.status} ${errorText}`);
    }

    return response.json();
};